import {useState, useEffect} from 'react'
import {Aff_question} from "./Aff_question"
import {MathJaxContext} from "better-react-mathjax";
import {niveaux} from "../config/Config";
import {useFetch} from "../hooks/useFetch";
import {useMsg} from "../hooks/useMsg";

export function QuestionSignal ({auth}) {

	const [quest, setQuest] = useState({
		niv:'',
		num:'',
		question:['', '', '', '', ''],
		signaler:false,
		describ:''
	})

	const {loading, data, errors, fetchApi, setData} = useFetch()

	const {msg, setMsg} = useMsg()

	let allNiv = ''
	niveaux.forEach(e => allNiv += e.slug)

const handleChange = (e) => {
	if(e.target.name === 'reference'){
  	let niv = e.target.value.replace('_p', 'p').split('_')[0]
  	const num = e.target.value.replace('_p', 'p').split('_')[1]
  	niveaux.forEach(e =>{
  		if (niv === e.slug.replace('maths', '').replace('-', '').replace('_pro', 'p').replace('spe', '').slice(0,5)) {niv = e.slug}
	  })
  	if(allNiv.includes(niv) && num) {
  		setQuest({...quest, question:['', '', '', '', ''], signaler:false, niv, num})
  	} else {
  		//setMsg('Veuillez saisir une référence de question valide.')
  		//cleanMsg()
  		//setQuest({...quest, question:['', '', '', '', ''], signaler:false})
  	}
	} else {
	  	setQuest({...quest, describ:e.target.value})
	}
}

const handleSubmit = (e) => {
	const action = e.target.name
	const ref = e.target.previousElementSibling.previousElementSibling.value
	
	if (action === 'rech_question') {
		// ======= Modifs ==========
		if(!ref.includes('_')){
			setMsg('Veuillez saisir une référence de question valide.', 'alert danger', 'fadeout3')
		} else {
	  	let niv = ref.replace('_p', 'p').split('_')[0]
	  	const num = ref.replace('_p', 'p').split('_')[1]
	  	niveaux.forEach(e =>{
  			if (niv === e.slug.replace('maths', '').replace('-', '').replace('_pro', 'p').replace('spe', '').slice(0,5)) {niv = e.slug}
	  	})
	  	if(allNiv.includes(niv) && num) {
	  		fetchApi('api-questions', {...auth, action:'admin_question', niveau:niv, num})
	  		setQuest({...quest, signaler:false, niv, num})
	  	}
		}
		//=============================
		/*if(data){setQuest({...quest, question:data})}
  	else {
  		setMsg('La question <b>'+quest.niv+'_'+quest.num+'</b> n\'existe pas.<br> Veuillez saisir une référence de question valide.')
  		cleanMsg()
  	}
	  	fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
		      method: 'POST',
		      body: JSON.stringify({...auth, action:'admin_question', niveau:quest.niv, num:quest.num})
		    })
		    .then(response => response.json())
		    .then(data => {
		    	//console.log('data Modal : ', data)
		      	if(data){setQuest({...quest, question:data})}
		      	else {
		      		setMsg('<div class="alert danger fadeout5"><br>La question <b>'+quest.niv+'_'+quest.num+'</b> n\'existe pas.<br> Veuillez saisir une référence de question valide.<br><br></div>')
		      		cleanMsg()
		      	}
		    	
		    })
		    .catch(err => console.log(err))*/
	} else {
	  	/*
	  	fetch("https://maths-au-quotidien.fr/react-automaths/api-msg.php", {
	      method: 'POST',
	      body: JSON.stringify({...auth, describe:quest.describ, num_question:quest.niv+'_'+quest.num})
	    })
	    .then(response => response.json())
	    .then(data => {})
	    .catch(err => console.log(err))
	    */

			fetchApi('api-msg', {...auth, describe:quest.describ, num_question:quest.niv+'_'+quest.num})

			setMsg('La question '+quest.niv+'_'+quest.num+' a bien été signalée aux administrateurs.<br> Merci !', 'success')
			setData(null)
			setQuest({...quest, signaler:false})
	}
  }

  useEffect(()=>{
    if(typeof window?.MathJax !== "undefined"){
      window.MathJax.typeset()
    }
  },[data]); // MathsJax 


const filtre = (text) => {
	let texte = text.trim().toLowerCase()
	return texte.split(' ').length > 1
	&& !texte.includes('(select ')
	&& !texte.includes(';select ')
	&& !texte.includes('select(')
	&& !texte.includes('xor')
	&& !texte.includes('make_set')
	&& !texte.includes('or not')
	&& !texte.includes(') or (')
	&& !texte.includes('having')
	&& !texte.includes('convert(')
	&& !texte.includes('order by')
	&& !texte.includes('in boolean mode')
	&& !texte.includes('extractvalue')
	&& !texte.includes('rlike')
  }

  return (
	<>
		<div className="content max QuestionSignal">
			<h1>Retrouver une question</h1>
			<div align="left">
				Dans cette partie, retrouver une question rapportée par un élève (pour faire le point sur une réponse non comprise) et/ou nous signaler une question comportant une anomalie.
			</div>
			<br/>
		  <div>
				Entrer la référence de la question : <input type="text" name="reference" className="styled" placeholder="exemple : 3e_2024" style={{textAlign:'center'}} /> <br/>
				{/*(quest.niv && quest.num) &&*/ <input type="button" name="rech_question" value="Rechercher" onClick={handleSubmit} />}
			</div>
			{ (data && data !== 'ok') && //quest.question[0] (Rq : le ok vient du 2e fetch api)
				<>
				<MathJaxContext>
					<Aff_question question={data}/>
				</MathJaxContext>
				<br/><br/>
				{data && <span>Voulez-vous signaler cette question ?</span>} <input type="button" value="oui" onClick={()=>setQuest({...quest, signaler:true})} />
				</>
			}
			{<span dangerouslySetInnerHTML={{ __html:msg}}></span>}
			{quest.signaler && <div>
				<textarea name="signalement" cols="40" rows="5" placeholder="Préciser le problème avec cette question." onChange={handleChange}></textarea> <br/>
				{filtre(quest.describ) && <input type="button" value="Signaler" onClick={handleSubmit} />}
			</div>}
		</div>
	</>
  );
}